<template>
  <div class="page-content">
    <header class="page-header">
      <div class="page-title">
        <h1>Devices</h1>
        <SettingsIcon />
      </div>

      <div class="button-group">
        <Button
          :title="'Add A Device'"
          :type="'raised'"
          :colorTheme="'primary'"
          @button-click="toggleNewDeviceDialog"
        />
      </div>
    </header>

    <div class="page-sub-header">
      <input
        class="search"
        v-model="searchText"
        type="text"
        placeholder="Search"
      >
    </div>

    <DeviceList
      :searchText="searchText"
      @display-edit-device-dialog="displayEditDeviceDialog"
    />

    <NewDevice
      v-if="showNewDeviceDialog"
      @hide-device-form="toggleNewDeviceDialog"
    />

    <EditDevice
      v-if="showEditDeviceDialog"
      :selectedDevice="device"
      @hide-device-form="hideEditDeviceDialog"
    />
  </div>
</template>

<script>
import DeviceList from '@/components/device/DeviceList'
import NewDevice from '@/components/device/NewDevice'
import EditDevice from '@/components/device/EditDevice'
import Button from '@/components/form-elements/Button'
import SettingsIcon from '@/components/assets/SettingsIcon'

export default {
  name: 'Project',
  components: {
    DeviceList,
    NewDevice,
    EditDevice,
    SettingsIcon,
    Button
  },
  data() {
    return {
      searchText: '',
      showNewDeviceDialog: false,
      showEditDeviceDialog: false,
      device: null
    }
  },
  methods: {
    displayEditDeviceDialog(device) {
      this.device = device
      this.showEditDeviceDialog = true
    },
    hideEditDeviceDialog() {
      this.showEditDeviceDialog = false
    },
    toggleNewDeviceDialog() {
      this.showNewDeviceDialog = !this.showNewDeviceDialog
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../../assets/styles/colors';
@import '../../assets/styles/mixin';
@import '../../assets/styles/input';
@import '../../assets/styles/page';
</style>



// WEBPACK FOOTER //
// src/components/device/Devices.vue